import React from 'react';
import { Route } from 'react-router-dom';
import NotFoundView from '../../views/NotFoundView';
import PrivateRoute from './PrivateRoute';
import ProgressFullscreen from 'components/common/ProgressFullscreen';

const ProtectedRoute = ({ isRouteAllowed, path, exact, component }) => {
  if (isRouteAllowed === undefined || isRouteAllowed === null) {
    return <ProgressFullscreen open />;
  }

  return isRouteAllowed ? (
    <PrivateRoute exact={exact} path={path} component={component} />
  ) : (
    <Route component={NotFoundView} />
  );
};

export default ProtectedRoute;
